import { IExternalPRNG } from '@kameleoon/javascript-sdk-core/browser';

export class KameleoonPRNG implements IExternalPRNG {
  public getRandomNumber(): number {
    if (typeof window !== 'undefined' && window?.crypto) {
      const arr = new Uint32Array(1);
      const uint32Max = 0xffffffff + 1;

      window.crypto.getRandomValues(arr);

      return arr[0] / uint32Max;
    }

    return Math.random();
  }
}
